'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tabs = require('./components/Tabs.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tabs).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-tabs/lib/components/tabs/index.js
// module id = 1198
// module chunks = 0